var _ = require('lodash');
const bodybuilder = require("bodybuilder");
import axios from "axios";

import elasticsearch from "elasticsearch";

const { Client } = require("elasticsearch");
const cdchabitat_es_client = Client({
  host: process.env.VUE_APP_ES_BASE_URL,
  httpAuth: `${process.env.VUE_APP_ES_USER}:${process.env.VUE_APP_ES_PASSWORD}`
});
// const CDCH_INDEX = "cdc_habitat_projects";
const CDCH_INDEX = process.env.VUE_APP_ES_CDCH_INDEX
const project_aggregations = {
  document_type: {
    terms: {
      field: "document_type.value",
      size: 10
    }
  },
  segment: {
    terms: {
      field: "segment.value",
      size: 25
    },
    aggs: {
      segment_data: {
        top_hits: {
          size: 1,
          _source: {
            includes: ["segment"]
          }
        }
      }
    }
  },
  publication_date: {
    date_histogram: {
      field: "publication_dates",
      interval: "year"
    }
  },
  region: {
    terms: {
      field: "geo.region_id.keyword",
      size: 25
    },
    aggs: {
      geo_data: {
        top_hits: {
          size: 1,
          _source: {
            includes: ["geo"]
          }
        }
      }
    }
  },
  city: {
    terms: {
      field: "geo.city.keyword",
      size: 2000
    },
    aggs: {
      geo_data: {
        top_hits: {
          size: 1,
          _source: {
            includes: ["geo"]
          }
        }
      }
    }
  }
};

const state = {
  nb_results: 0,
  projects: [],
  query: "",
  city_map: {},
  dpt_map: {},
  geo_items: [],
  bounding_box: {
    update_projects: false,
    north: 0.0,
    east: 0.0,
    south: 0.0,
    west: 0.0
  },
  facets: {
    years: [],
    document_types: [],
    segments: [],
    regions: [],
    cities: []
  },
  filters: {
    year: "",
    document_type: "",
    location: "",
    segment: "",
    region: "",
    study_name: "",
    relance: ""
  },
  last_filter: null,
  results_per_doc_type: []
};

const getters = {
  projects(state) {
    return state.projects;
  },
  nb_results(state) {
    return state.nb_results;
  },
  query(state) {
    return state.query;
  },
  facets(state) {
    return state.facets;
  },
  filters(state) {
    return state.filters;
  },
  results_per_doc_type(state) {
    return state.results_per_doc_type;
  },
  city_map(state) {
    return state.city_map;
  },
  dpt_map(state) {
    return state.dpt_map;
  },
  bounding_box(state) {
    return state.bounding_box;
  },
  geo_items(state) {
    return state.geo_items;
  }
};

let ajaxTimeout = null;

const actions = {
  // save the typed query
  set_query({ commit, state }, data) {
    commit("SET_QUERY", { query: data.query });
  },
  remove_all_filters({ commit, state, dispatch }, data) {
    let filters = [];
    _.forOwn(state.filters, function(value, key) {
      filters[key] = null;
    });
    commit("SET_FILTER", filters);
    dispatch("load_projects");
  },
  set_filter({ commit, state }, data) {
    commit("SET_FILTER", data);
  },
  set_facet({ commit, state }, data) {
    commit("SET_FACET", data);
  },
  set_nb_results({ commit, state }, data) {
    commit("SET_NB_RESULTS", { nb_results: data.nb_results });
  },
  // Vide le tableau d'études
  clear_projects({ commit }, data) {
    commit("SET_PROJECTS", { projects: [] });
  },
  set_bounding_box(
    { commit, state, dispatch },
    { bounding_box, resetLocation = false }
  ) {
    bounding_box.update_projects = true;
    // set the bounding box
    commit("SET_BOUNDING_BOX", { bounding_box });
    // cancel the location filter
    if (resetLocation) {
      commit("SET_FILTER", { location: null });
    }
    // reload the projects
    dispatch("load_projects");
  },
  async load_projects_v2({commit, state, dispatch}){
    if (state.loading) {
      return; // already doing something
    }
    dispatch("set_loading", { loading: true });
    console.trace()
    const filter = {
      "region": state.filters.region,
      "bounding_box": state.bounding_box
    }
    const baseURL = process.env.VUE_APP_NEW_API_BASE_URL;
    const projects= (await axios.post( `${ process.env.VUE_APP_NEW_API_BASE_URL}api/projet/search`, filter)).data.content;
    // dispatch("set_search_results", projects);
    commit("SET_PROJECTS", { projects: projects }); // a enlever car appellée dans set_search_results
    // commit("SET_FACET", facets_to_update); // a enlever car appellée dans set_search_results
    commit("SET_NB_RESULTS", { nb_results: projects.length });

    dispatch("set_loading", { loading: false });

    if (data) {
      data.results = results;
    } else {
      data = { results: results };
    }
    // dispatch("set_search_results", data); // { results: results });
    // commit("RESET_BOUNDING_BOX_UPDATE_STATUS"); // voir à quoi cette méthode sert
  },
  async load_projects({ commit, state, dispatch }, data) {
    if (state.loading) {
      return; // already doing something
    }
    // if data.mode == home, perform an empty query
    var empty_query = false;
    var query_string = "";
    if (data && data.mode && data.mode == "home") {
      empty_query = true;
    } else {
      query_string = state.query;
    }

    dispatch("set_loading", { loading: true });

    let bb = state.bounding_box;
    var filters = null;
    if (
      !empty_query &&
      (state.filters.year ||
        state.filters.document_type ||
        state.filters.location ||
        state.filters.segment ||
        state.filters.region ||
        state.filters.study_name || 
        state.filters.relance ||
        state.bounding_box.update_projects)
    ) {
      filters = [];
      if (state.filters.year) {
        filters.push({
          range: {
            publication_dates: {
              gte: state.filters.year,
              lte: state.filters.year + 1,
              format: "dd/MM/yyyy||yyyy"
            }
          }
        });
      }
      if (state.filters.document_type) {
        filters.push({
          term: {
            "document_type.value": state.filters.document_type
          }
        });
      }
      if (state.filters.segment) {
        filters.push({
          term: {
            "segment.value": state.filters.segment // .key
          }
        });
      }
      if (state.filters.region) {
        filters.push({
          term: {
            "geo.region_id.keyword": state.filters.region
          }
        });
      }

      if (state.filters.relance) {
        console.log('jna filter relance : ',state.filters.relance)
        // transform 1/2 => true/false
        let relance_bool =  state.filters.relance =="1"  ? true : false;

        filters.push({
          term: {
            "relance": relance_bool
          }
        });
      }

      if (state.filters.study_name) {
        filters.push({
          // match : chaque terme entier
          match: {
            name: {
              query: "*" + state.filters.study_name + "*",
              operator: "and"
            }
          }

          // querry_sting * : trop souple
          // "query_string": {
          // 	"fields": [ "name"],
          // 	"query": "*"+state.filters.study_name+"*"
          // 	// "operator" : "and"
          // }

          //fuzzy : pas parfait - difficile à maintriser
          // "fuzzy": {
          // 	"name": {
          // 		"value": state.filters.study_name,
          // 		"fuzziness": "3",
          // 		"max_expansions": 4,
          // 		"prefix_length": 0,
          // 		 "transpositions": true,
          // 		 "rewrite": "constant_score"
          // 			// "operator" : "and"
          // 	}
          // }
        });
      }

      // if bounding box was just updated, ignore the location filter
      if (bb.update_projects) {
        // console.log('using bounding box');
        filters.push({
          geo_bounding_box: {
            location: {
              top_left: [bb.west, bb.north],
              bottom_right: [bb.east, bb.south]
            }
          }
        });
      }

      if (state.filters.location && state.filters.location.coordinates) {
        if (state.bounding_box.update_projects) {
          console.error(
            "this should not happen as bounding_box.update == true"
          );
        }
        const polygon =
          state.filters.location.coordinates.length === 1
            ? state.filters.location.coordinates[0]
            : state.filters.location.coordinates;

        if(state.filters.location.type == "city"){
          filters.push({
            bool:{
              should:[
                {
                  geo_polygon: {
                    location: {
                      points: polygon
                    }
                  }
                },
                {
                  term:{"geo.insee_code.keyword": state.filters.location.insee_id }
                }

              ]
            }
          });
        }
        else if(state.filters.location.type == "dpt"){
          filters.push({
            bool:{
              should:[
                {
                  geo_polygon: {
                    location: {
                      points: polygon
                    }
                  }
                },
                {
                  term:{"geo.department_id.keyword": state.filters.location.department_code }
                }
              ]
            }
          });
        }
        else{
          filters.push({
            geo_polygon: {
              location: {
                points: polygon
              }
            }
          });
        }
       

      }
    }

    var query_body = {
      from: 0,
      size: 250,
      sort: [{ publication_dates: "desc" }],
      query: {
        bool: {
          must: {
            match: {
              name: {
                query: query_string,
                zero_terms_query: "all"
              }
            }
          }
        }
      },
      aggs: project_aggregations
    };
    if (filters && filters.length > 0) {
      // console.log("adding filters", filters);
      query_body.query.bool.filter = filters;
    }
    // console.log(JSON.stringify(query_body, undefined, 2));

    try {
      clearTimeout(ajaxTimeout);

      const results = await new Promise(async resolve => {
        ajaxTimeout = setTimeout(
          async () => {
            const res = await cdchabitat_es_client.search({
              index: CDCH_INDEX,
              body: query_body
            });
            ajaxTimeout = null;
            resolve(res);
          },
          ajaxTimeout ? 1500 : 1000
        );
      });
      // const results = await cdchabitat_es_client.search({ index: CDCH_INDEX, body: query_body });
      if (data) {
        data.results = results;
      } else {
        data = { results: results };
      }
      dispatch("set_search_results", data); // { results: results });
      dispatch("set_loading", { loading: false });
      commit("RESET_BOUNDING_BOX_UPDATE_STATUS");
    } catch (error) {
      console.error(error);
      dispatch("clear_projects");
      dispatch("set_loading", { loading: false });
      commit("RESET_BOUNDING_BOX_UPDATE_STATUS");
    }
  },

  async geo_polygon_search({ commit, state, dispatch }, data) {
    dispatch("set_loading", { loading: true });

    const polygon = data.polygon;
    const polygon_query = {
      geo_polygon: {
        ignore_unmapped: true,
        location: {
          points: data.polygon
        }
      }
    };
    const query_body = {
      size: 200,
      query: polygon_query,
      aggs: project_aggregations
    };
    // console.log(JSON.stringify(query_body, undefined, 1));
    try {
      const results = await cdchabitat_es_client.search({
        index: CDCH_INDEX,
        body: query_body
      });
      dispatch("set_search_results", { results: results });
      dispatch("set_loading", { loading: false });
    } catch (error) {
      dispatch("set_loading", { loading: false });
    }
  },

  set_search_results({ commit, state, dispatch }, data) {
    if (!data || !data.results) {
      console.error("invalid set_results call, data.results is required");
      return;
    }
    let should_update_cities = false;
    if (data.initial_search == true) {
      should_update_cities = true;
    }

    let results = data.results;
    var hits = results.hits.hits;
    var projects = _.map(hits, "_source");
    var facets_to_update = {};

    const aggs = results.aggregations;

    if (state.last_filter != "year" && state.last_filter != "study_name") {
      var years = [];
      if (aggs.publication_date && aggs.publication_date.buckets) {
        _.forEach(aggs.publication_date.buckets, function(yearBucket) {
          var year = Number(yearBucket.key_as_string.split("-")[0]);
          years.push(year);
        });
      }
      _.reverse(years);
      facets_to_update.years = years;
    }

    if (state.last_filter != "document_types") {
      let doc_types = [];
      if (aggs.document_type && aggs.document_type.buckets) {
        doc_types = aggs.document_type.buckets;
      }
      facets_to_update.document_types = doc_types;
    }

    if (state.last_filter != "region" && state.last_filter != "study_name") {
      let regions = {};
      if (aggs.region && aggs.region.buckets) {
        // regions = aggs.region.buckets;
        _.forEach(aggs.region.buckets, bucket => {
          bucket.region_name =
            bucket.geo_data.hits.hits[0]._source.geo.region_name;
          delete bucket.geo_data;
          regions[bucket.key] = bucket;
        });
      }
      facets_to_update.regions = regions;
    }
    if (should_update_cities) {
      // && state.last_filter != 'cities') {
      console.log("updating city list");
      let cities = [];
      let dpt_map = {};
      if (aggs.city && aggs.city.buckets) {
        _.forEach(aggs.city.buckets, bucket => {
          const city_data = {
            key: bucket.key,
            doc_count: bucket.doc_count,
            department_id:
              bucket.geo_data.hits.hits[0]._source.geo.department_id,
            insee_code: bucket.geo_data.hits.hits[0]._source.geo.insee_code
          };
          cities.push(city_data);
          if (dpt_map[city_data.department_id]) {
            dpt_map[city_data.department_id] += city_data.doc_count;
          } else {
            dpt_map[city_data.department_id] = city_data.doc_count;
          }
        });
      }
      facets_to_update.cities = cities;

      const city_map = _.keyBy(cities, "insee_code");

      // lyon
      // console.log('lyon', city_map[69123])
      if (_.isUndefined(city_map[69123])) {
        city_map[69123] = {
          key: "Lyon",
          doc_count: 0,
          department_id: "69",
          insee_code: "69123"
        };
      }
      for (let arr_code of [
        69381,
        69382,
        69383,
        69384,
        69385,
        69386,
        69387,
        69388,
        69389
      ]) {
        // console.log(arr_code)
        if (!_.isUndefined(city_map[arr_code])) {
          city_map[69123].doc_count += city_map[arr_code].doc_count;
        }
      }
      console.log("lyon", city_map[69123].doc_count);
      // marseille
      // console.log('marseille', city_map[13055])
      if (_.isUndefined(city_map[13055])) {
        city_map[13055] = {
          key: "Marseille",
          doc_count: 0,
          department_id: "13",
          insee_code: "13055"
        };
      }
      for (let arr_code of [
        13201,
        13202,
        13203,
        13204,
        13205,
        69366,
        13207,
        13208,
        13209,
        13210,
        13211,
        13212,
        13213,
        13214,
        13215,
        13216
      ]) {
        // console.log(arr_code)
        if (!_.isUndefined(city_map[arr_code])) {
          city_map[13055].doc_count += city_map[arr_code].doc_count;
        }
      }
      console.log("marseille", city_map[13055].doc_count);
      // paris
      if (_.isUndefined(city_map[75056])) {
        city_map[75056] = {
          key: "Paris",
          doc_count: 0,
          department_id: "75",
          insee_code: "75056"
        };
      }
      for (let arr_code of [
        75101,
        75102,
        75103,
        75104,
        75105,
        69366,
        75107,
        75108,
        75109,
        75110,
        75111,
        75112,
        75113,
        75114,
        75115,
        75116,
        75117,
        75118,
        75119,
        75120
      ]) {
        // console.log(arr_code)
        if (!_.isUndefined(city_map[arr_code])) {
          city_map[75056].doc_count += city_map[arr_code].doc_count;
        }
      }
      console.log("paris", city_map[75056].doc_count);
      commit("SET_GEO_MAPPING", { city_map: city_map, dpt_map: dpt_map });
    }

    //// segment facet
    if (state.last_filter != "segment" && state.last_filter != "study_name") {
      let segments = {};
      if (aggs.segment && aggs.segment.buckets) {
        _.forEach(aggs.segment.buckets, bucket => {
          const segment_data = {
            key: bucket.key,
            doc_count: bucket.doc_count,
            slug: bucket.segment_data.hits.hits[0]._source.segment.slug,
            initials: bucket.segment_data.hits.hits[0]._source.segment.initials
          };
          segments[bucket.key] = segment_data;
        });
      }
      facets_to_update.segments = segments;
    }

    commit("SET_FACET", facets_to_update);
    commit("SET_NB_RESULTS", { nb_results: results.hits.total });
    commit("SET_PROJECTS", { projects: projects });
  },
  async search_geo_areas_by_name({ commit, state, dispatch }, data) {
    let query_body = bodybuilder()
      .query("query_string", { default_field: "name", query: data.text + "*" })
      .size(200)
      .build();
    const response = await cdchabitat_es_client.search({
      index: "geo_polygon",
      body: query_body
    });
    dispatch("process_geo_areas_response", { response: response });
  },
  async search_geo_areas_by_number({ commit, state, dispatch }, data) {
    if (!data || !data.text) {
      console.error("wrong data in search_geo_areas_by_number");
      return;
    }

    console.log(data.text);
    // if length == 2, search on department_code.keyword
    if (data.text.length == 2) {
      // search on departement id
      let query_body = bodybuilder()
        .filter("term", "department_code.keyword", data.text)
        .build();
      const response = await cdchabitat_es_client.search({
        index: "geo_polygon",
        body: query_body
      });
      dispatch("process_geo_areas_response", { response: response });
    }
    // if length >2, search on insee_id with * wildcard
    if (data.text.length > 2) {
      let query_body = bodybuilder()
        .query("query_string", {
          default_field: "insee_id",
          query: data.text + "*"
        })
        .size(100)
        .sort("insee_id.keyword", "asc")
        .build();
      const response = await cdchabitat_es_client.search({
        index: "geo_polygon",
        body: query_body
      });
      dispatch("process_geo_areas_response", { response: response });
    }
  },
  process_geo_areas_response({ commit, state, dispatch }, data) {
    const response = data.response;
    let geo_items = _.map(response.hits.hits, "_source");
    _.forEach(geo_items, item => {
      item.doc_count = 0;
      if (item.type == "city") {
        item.department_code = item.insee_id.substring(0, 2);
        if (state.city_map[item.insee_id]) {
          item.doc_count = state.city_map[item.insee_id].doc_count;
        }
      }
      if (item.type == "dpt") {
        if (state.dpt_map[item.department_code]) {
          item.doc_count = state.dpt_map[item.department_code];
        }
      }
    });
    geo_items = _.sortBy(geo_items, "doc_count");
    _.reverse(geo_items);
    commit("SET_GEO_SUGGESTIONS", { items: geo_items });
  }
};

const mutations = {
  SET_QUERY(state, data) {
    state.query = data.query;
  },

  SET_FILTER(state, data) {
    state.last_filter = "";
    _.forOwn(data, function(value, key) {
      state.filters[key] = value;
      if (value) {
        state.last_filter = key;
      }
    });
  },

  SET_FACET(state, data) {
    _.forOwn(data, function(value, key) {
      state.facets[key] = value;
    });
  },

  SET_NB_RESULTS(state, data) {
    state.nb_results = data.nb_results;
  },

  SET_PROJECTS(state, data) {
    //JNA : Sort projets by name
    state.projects = _.orderBy(data.projects,['name'],['asc']);
  },

  SET_RESULTS_PER_DOC_TYPE(state, data) {
    state.results_per_doc_type = data.results;
  },

  SET_GEO_MAPPING(state, data) {
    state.city_map = data.city_map;
    state.dpt_map = data.dpt_map;
  },

  SET_BOUNDING_BOX(state, data) {
    // console.log('setting bounding box', data);
    state.bounding_box = data.bounding_box;
  },
  RESET_BOUNDING_BOX_UPDATE_STATUS() {
    state.bounding_box.update_projects = false;
  },
  SET_GEO_SUGGESTIONS(state, data) {
    state.geo_items = data.items;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
